/**
 * mmc_module_registry.js
 * Module registration and component mapping system
 */

class MmcModuleRegistry {
  constructor() {
    this.modules = new Map();
    this.components = new Map();
  }

  /**
   * Register a module
   * @param {Object} manifest - Module manifest
   * @param {React.Component} component - React component
   */
  register_module(manifest, component) {
    if (!manifest.id) {
      throw new Error('Module manifest must have an id');
    }

    this.modules.set(manifest.id, manifest);
    this.components.set(manifest.id, component);
  }

  /**
   * Get all registered modules
   * @returns {Array} Array of module manifests
   */
  get_modules() {
    return Array.from(this.modules.values());
  }

  /**
   * Get module by ID
   * @param {string} module_id - Module identifier
   * @returns {Object|null} Module manifest
   */
  get_module(module_id) {
    return this.modules.get(module_id) || null;
  }

  /**
   * Get component for module
   * @param {string} module_id - Module identifier
   * @returns {React.Component|null} React component
   */
  get_component(module_id) {
    return this.components.get(module_id) || null;
  }

  /**
   * Check if module is registered
   * @param {string} module_id - Module identifier
   * @returns {boolean} True if registered
   */
  has_module(module_id) {
    return this.modules.has(module_id);
  }

  /**
   * Get all registered components
   * @returns {Map} Map of module IDs to components
   */
  get_components() {
    return this.components;
  }

  /**
   * Unregister a module
   * @param {string} module_id - Module identifier
   */
  unregister_module(module_id) {
    this.modules.delete(module_id);
    this.components.delete(module_id);
  }

  /**
   * Clear all modules
   */
  clear() {
    this.modules.clear();
    this.components.clear();
  }
}

export default MmcModuleRegistry;
